import axios from "axios";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

async function UploadFile(
  file: File,
  bucketName: string,
  key: string,
  accessToken: string
): Promise<string | undefined> {
  try {
    let fileData = {
      BucketName: bucketName,
      Key: key,
      ContentType: file?.type,
      IsPublicRead: true
    };

    const presignResponse = await GeneratePresignUrl(fileData, accessToken);

    const headers = {
      "Content-Type": file.type
    };

    await fetch(presignResponse?.PreSignUrl, {
      method: "PUT",
      body: file,
      headers: headers
    });

    // return `https://${bucketName}.s3.amazonaws.com/${key}`;
    return presignResponse?.AccessUrl;
  } catch (error) {
    throw Error("Failed to Upload video, Please try again!");
  }
}

async function GeneratePresignUrl(
  fileData: any,
  accessToken: any
): Promise<any> {
  try {
    let data = JSON.stringify(fileData);

    let config: any = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiBaseUrl}/cardpanels/s3presignurl`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      data: data
    };

    const response = await axios.request(config);
    console.log("🚀 ~ response:", response);
    return response.data;
  } catch (error) {
    console.log("Error:", error);
    throw Error("Error uploading file");
  }
}

export default UploadFile;
